// Copyright 1999-2026. WebPros International GmbH. All rights reserved.

export default () => document.documentElement.dir === 'rtl';
